import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Container } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";

function UtschoolPageHeader() {
  const pageHeader = useRef(null); // Use 'useRef' instead of 'React.createRef()'
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration for text
      easing: "ease-in-out", // Smoother animation
    });

    // Fetch the background image (cover) from the API
    axios
      .get(`${process.env.REACT_APP_API_URL}/utschool/readUtschool`)
      .then((response) => {
        if (response.data.length > 0) {
          setBgImage(response.data[0].cover); // Assuming 'cover' is the image URL
        }
      })
      .catch((error) => {
        console.error("Error fetching background image:", error);
      });

    // Scroll effect for the page header
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        if (pageHeader.current) {
          let windowScrollTop = window.pageYOffset / 3;
          pageHeader.current.style.transform =
            "translate3d(0," + windowScrollTop + "px,0)";
        }
      };
      window.addEventListener("scroll", updateScroll);

      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, []);

  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage: bgImage ? `url(${bgImage})` : "none",
          }}
          ref={pageHeader} // Assign ref to the element
        ></div>
        <div className="content-center">
          <Container>
            <h2
              className="title"
              data-aos="fade-left"
              dangerouslySetInnerHTML={{ __html: "SEKILAS UT SCHOOL" }}
            ></h2>
            <div className="underline" data-aos="fade-right" data-aos-delay="300"></div>
            <div className="text-center">
              {/* Add more content here if needed */}
            </div>
          </Container>
        </div>
      </div>
      <style jsx>{`
        .underline {
          width: 200px;
          height: 4px;
          background-color: white;
          margin: 10px auto;
          transition: all 1.5s ease; // Smooth transition for underline
        }
      `}</style>
    </>
  );
}

export default UtschoolPageHeader;
